import React, { memo, useEffect, useState } from "react";
import { createPortal } from "react-dom";
const EditorPortalsRaw = ({ portalContainer, }) => {
    const [portals, setPortals] = useState(portalContainer.entries());
    useEffect(() => {
        return portalContainer.subscribe((portalsMap) => setPortals(Array.from(portalsMap.entries())));
    }, [portalContainer]);
    return (React.createElement(React.Fragment, null, portals.map(([container, { component: Component, key }]) => createPortal(React.createElement(Component, null), container, key))));
};
export const EditorPortals = memo(EditorPortalsRaw);
